// src/utils/aiContext.ts
//
// Helpers de détection de contexte pour l'assistant IA conversationnel.
// Fournit le module courant et la page consultée afin que l'IA puisse
// adapter ses réponses (ex : "Je vois que tu es sur la fiche d'un employé").
//
// Mai 2026.

export function detecterModule(pathname: string): string | null {
  // Électricité (EEC / E²C) — placé en premier : ces routes doivent activer le
  // mode tool-use électricité de l'assistant IA (facturation, branchements,
  // relevés, abonnements, carte SIG…).
  if (
    pathname.startsWith('/facturation-electrique')
    || pathname.startsWith('/electricite')
    || pathname.startsWith('/branchement')
    || pathname.startsWith('/sig')
    || pathname.startsWith('/consolidation-electricite')
    || /electriq|branchement|compteur|abonnement|releve|recouvrement-electr/i.test(pathname)
  ) return 'electricite';
  if (
    pathname.startsWith('/rh')
    || pathname.startsWith('/capital-humain')
    || pathname.startsWith('/capitalhumain')
    || /employe|employ%C3%A9|conge|cong%C3%A9|paie|bulletin|gpec|recrutement|formation|evaluation|organigramme|mon-equipe|mes-collegues/i.test(pathname)
  ) return 'rh';
  if (
    pathname.startsWith('/self-service')
    || pathname.startsWith('/selfservice')
    || pathname.startsWith('/mon-espace')
    || pathname.startsWith('/monespace')
    || /mes-demandes|ma-demission|disponibilite|demande-conge|demande-absence|demande-formation/i.test(pathname)
  ) return 'self-service';
  if (pathname.startsWith('/location')) return 'location';
  if (pathname.startsWith('/caisse')) return 'caisse';
  if (pathname.startsWith('/stock')) return 'stock';
  if (pathname.startsWith('/factures') || pathname.startsWith('/clients')) return 'crm';
  if (pathname.startsWith('/immobilier')) return 'immobilier';
  if (pathname.startsWith('/comptabilite')) return 'comptabilite';
  if (pathname.startsWith('/statistiques')) return 'statistiques';
  if (pathname.startsWith('/admin')) return 'administration';
  return null;
}

export function getContextPage(): { contextePage: string; contexteModule: string | null } {
  return {
    contextePage: window.location.pathname,
    contexteModule: detecterModule(window.location.pathname),
  };
}
